module.exports = __webpack_public_path__ + "static/ShortVersion.41457e79.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/data/ShortVersion.mp3
// module id = 482
// module chunks = 35783957827783